import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

// Material

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
//import 'vue-material/dist/theme/default.css'
Vue.use(VueMaterial)

// Sass
import './assets/scss/app.scss'

import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(VueAxios, axios)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
